import { useEffect, useState } from "react";
import { FiPhone } from "react-icons/fi";
import { RxIdCard } from "react-icons/rx";
import ModalElement from "../../../Common/ModalElement"
import InputElement from "../../../Common/InputElement";
import ButtonElement from "../../../Common/ButtonElement";
import SearchableDropdown from "../../../Common/SearchDropdown";
import { validateFields, commonOnChange, commonOnSelect, isValidObject } from "../../../utils";
import { GoPerson } from "react-icons/go";
import { TbWallet } from "react-icons/tb";
import { RiBankLine } from "react-icons/ri";
import { appApis, dropdownDefaultList } from "../../../constants";
import { MdOutlineCurrencyRupee } from "react-icons/md";
import { useApiRequest } from "../../../hooks/useApiRequest";
import CountryStateCityDropdown from "../../../Common/CountryDropDown";
import { useDispatch } from "react-redux";
import { setIntsallerList } from "../../../actions/installer";

const getPayload = (stateData) => {
    const { fullName, mobileNo, altMobleNo, state, city, address, employmentType, amount, bikeProvided, bikeRegNo, bikeIssueDate, adharPanNo, dLNumber, accNo, ifscCode, accName } = stateData;
    return {
        name: fullName,
        mobileNo,
        altMobleNo,
        city,
        state,
        country: "India",
        address,
        salaryType: employmentType,
        salary: amount,
        bikeProvided: bikeProvided == "Yes",
        bikeIssueDate: bikeIssueDate || null,
        bikeRegistrationNumber: bikeRegNo || null,
        kycDocNumber: adharPanNo || null,
        drivingLicenseNumber: dLNumber || null,
        bankingDetails: {
            ifscCode,
            accountNumber: accNo,
            accountHldName: accName
        }
    }
}

const AddInstaller = ({ show, hideModal, installerData, getInstData }) => {
    const [details, setDetails] = useState({
        fullName: "",
        mobileNo: "",
        altMobleNo: "",
        deviceType: "",
        state: "",
        city: "",
        address: "",
        employmentType: "",
        amount: "",
        bikeProvided: "No",
        bikeRegNo: "",
        bikeIssueDate: "",
        adharPanNo: "",
        dLNumber: "",
        accNo: "",
        ifscCode: "",
        accName: "",
        fullNameErr: null,
        mobileNoErr: null,
        altMobleNoErr: null,
        deviceTypeErr: null,
        stateErr: null,
        cityErr: null,
        addressErr: null,
        employmentTypeErr: null,
        adharPanNoErr: null,
        bikeRegNoErr: null,
        bikeIssueDateErr: null,
        dLNumberErr: null,
        accNoErr: null,
        ifscCodeErr: null,
        amountErr: null,
        accNameErr: null
    });

    const { fullName, mobileNo, altMobleNo, state, city, address, employmentType, amount, bikeProvided, amountErr, bikeRegNo, bikeIssueDate, adharPanNo, dLNumber, accNo, ifscCode, accName, fullNameErr, mobileNoErr, altMobleNoErr, stateErr, cityErr, addressErr, employmentTypeErr, bikeRegNoErr, bikeIssueDateErr, adharPanNoErr, dLNumberErr, accNoErr, ifscCodeErr, accNameErr } = details;
    const { request: submitRequest, loading } = useApiRequest();
    const dispatch = useDispatch()

    const onChangeHandler = (event) => commonOnChange(event, setDetails);
    const onSelectHandler = (event) => commonOnSelect(event, setDetails);
    const countryHandler = (details) => {
        setDetails(prev => ({ ...prev, ...details }))
    }

    const submit = () => {
        const bikeDetails = bikeProvided == "Yes" ? {
            bikeRegNoErr: [bikeRegNo, "text"],
            bikeIssueDateErr: [bikeIssueDate, "text"]
        } : {};
        validateFields(
            {
                fullNameErr: [fullName, "text"],
                mobileNoErr: [mobileNo, "phone"],
                employmentTypeErr: [employmentType, "text"],
                amountErr: [amount, "number"],
                ...bikeDetails
            },
            setDetails,
            () => {
                const payload = getPayload(details);
                const isUpdate = installerData?.installerId ?? null;
                submitRequest({
                    method: isUpdate ? "PUT" : "POST",
                    url: `${appApis.getInstallers}${isUpdate ? `/${isUpdate}` : ""}`,
                    body: payload,
                    onSuccess: () => {
                        dispatch(setIntsallerList());
                        getInstData();
                        setTimeout(hideModal, 1000);
                    }
                })
            }
        )
    }

    useEffect(() => {
        if (isValidObject(installerData)) {
            setDetails(prev => ({
                ...prev,
                fullName: installerData?.name ?? "",
                mobileNo: installerData?.mobileNo ?? "",
                altMobleNo: installerData?.altMobleNo ?? "",
                city: installerData?.city ?? "",
                state: installerData?.state ?? "",
                address: installerData?.address ?? "",
                employmentType: installerData?.salaryType ?? "",
                amount: installerData?.salary ?? "",
                bikeProvided: (installerData?.bikeProvided ?? false) ? "Yes" : "No",
                bikeRegNo: installerData?.bikeRegistrationNumber ?? "",
                bikeIssueDate: installerData?.bikeIssueDate ?? "",
                adharPanNo: installerData?.kycDocNumber ?? "",
                dLNumber: installerData?.drivingLicenseNumber ?? "",
                accNo: installerData?.bankingDetails?.accountNumber ?? "",
                ifscCode: installerData?.bankingDetails?.ifscCode ?? "",
                accName: installerData?.bankingDetails?.accountHldName ?? ""
            }))
        }
    }, [installerData])


    return <ModalElement height={"90vh"} size="lg" show={show} title={"Add Installer"} onHide={hideModal} FooterComponent={<div className="submit-btn text-center mb-3">
        <ButtonElement text={"Submit"} cssClass="small-radius mb-1" onClick={submit} variant="btn-outline-primary" loading={loading} />
    </div>}>
        <div className="add-installer text-start">
            <div className="installer-personal mb-3">
                <h5 className="mb-3">Personal Details</h5>
                <div className="row">
                    <div className="col-lg-4 col-md-6 mb-2">
                        <InputElement
                            label={"Full Name"}
                            placeholder={"Enter Full Name"}
                            name={"fullName"}
                            value={fullName}
                            error={fullNameErr}
                            icon={<GoPerson size={20} />}
                            onChange={onChangeHandler}
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-2">
                        <InputElement
                            label={"Mobile Number"}
                            placeholder={"Enter Number"}
                            name={"mobileNo"}
                            value={mobileNo}
                            error={mobileNoErr}
                            icon={<FiPhone size={20} />}
                            onChange={onChangeHandler}
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-2">
                        <InputElement
                            label={"Alt Mobile Number (opt)"}
                            placeholder={"Enter Alt. Number"}
                            name={"altMobleNo"}
                            isRequired={false}
                            value={altMobleNo}
                            error={altMobleNoErr}
                            icon={<FiPhone size={20} />}
                            onChange={onChangeHandler}
                        />
                    </div>
                    <CountryStateCityDropdown {...{ onSelectHandler: countryHandler, city, state, country: "India", stateErr, cityErr }} />
                    <div className="col-12 mb-2">
                        <InputElement
                            isTextArea={true}
                            isRequired={false}
                            label={"Address"}
                            placeholder={"Enter Address"}
                            name={"address"}
                            value={address}
                            error={addressErr}
                            onChange={onChangeHandler}
                        />
                    </div>
                </div>
            </div>
            <div className="installer-classification mb-3">
                <h5 className="mb-3">Bike Details</h5>
                <div className="row">
                    <div className="col-md-6 mb-2">
                        <SearchableDropdown
                            label={"Employment Type"}
                            placeholder={"Select Employment Type"}
                            value={employmentType}
                            error={employmentTypeErr}
                            options={dropdownDefaultList.employmentType}
                            onSelect={(value) => onSelectHandler({ target: { name: "employmentType", value } })}
                        />
                    </div>
                    {employmentType ? <div className="col-md-6 mb-2">
                        <InputElement
                            label={`${employmentType == "Salaried" ? "Salary" : employmentType}`}
                            placeholder={`Enter ${employmentType == "Salaried" ? "Salary" : employmentType}`}
                            name={"amount"}
                            value={amount}
                            error={amountErr}
                            icon={<MdOutlineCurrencyRupee size={20} />}
                            onChange={onChangeHandler}
                        />
                    </div> : null}
                    <div className="col-md-6 mb-2">
                        <SearchableDropdown
                            label={"Bike Provided"}
                            placeholder={"Select Bike Provided"}
                            value={bikeProvided}
                            error={false}
                            options={dropdownDefaultList.confirmation}
                            onSelect={(value) => onSelectHandler({ target: { name: "bikeProvided", value } })}
                        />
                    </div>
                </div>
            </div>
            {bikeProvided == "Yes" ? <div className="bike-details mb-3">
                <h5 className="mb-3">Bike Details</h5>
                <div className="row">
                    <div className="col-md-6 mb-2">
                        <InputElement
                            label={"Bike Reg. No."}
                            placeholder={"Enter Bike Reg. No."}
                            name={"bikeRegNo"}
                            value={bikeRegNo}
                            error={bikeRegNoErr}
                            onChange={onChangeHandler}
                        />
                    </div>
                    <div className="col-md-6 mb-2">
                        <InputElement
                            type="date"
                            label={"Bike Issue Date"}
                            placeholder={"Enter Bike Issue Date"}
                            name={"bikeIssueDate"}
                            value={bikeIssueDate}
                            error={bikeIssueDateErr}
                            onChange={onChangeHandler}
                        />
                    </div>
                </div>
            </div> : null}
            <div className="installer-kyc-details mb-3">
                <h5 className="mb-3">KYC Details</h5>
                <div className="row">
                    <div className="col-md-6 mb-2">
                        <InputElement
                            isRequired={false}
                            label={"Aadhaar/PAN number"}
                            placeholder={"Enter Aadhaar/PAN number "}
                            name={"adharPanNo"}
                            value={adharPanNo}
                            error={adharPanNoErr}
                            icon={<RxIdCard size={20} />}
                            onChange={onChangeHandler}
                        />
                    </div>
                    <div className="col-md-6 mb-2">
                        <InputElement
                            label={"Driving License number"}
                            placeholder={"Enter Driving License number"}
                            name={"dLNumber"}
                            isRequired={false}
                            value={dLNumber}
                            error={dLNumberErr}
                            icon={<RxIdCard size={20} />}
                            onChange={onChangeHandler}
                        />
                    </div>
                </div>
            </div>
            <div className="installer-bank-details mb-3">
                <h5 className="mb-3">Bank Account Information</h5>
                <div className="row">
                    <div className="col-lg-4 col-md-6 mb-2">
                        <InputElement
                            label={"Account Number"}
                            placeholder={"Enter Account Number"}
                            name={"accNo"}
                            value={accNo}
                            isRequired={false}
                            error={accNoErr}
                            icon={<TbWallet size={20} />}
                            onChange={onChangeHandler}
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-2">
                        <InputElement
                            label={"IFSC Code"}
                            placeholder={"Enter IFSC Code"}
                            name={"ifscCode"}
                            value={ifscCode}
                            isRequired={false}
                            error={ifscCodeErr}
                            icon={<RiBankLine size={20} />}
                            onChange={onChangeHandler}
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-2">
                        <InputElement
                            label={"Account Holder Name"}
                            placeholder={"Enter Acc. Holder Name"}
                            name={"accName"}
                            value={accName}
                            isRequired={false}
                            error={accNameErr}
                            icon={<GoPerson size={20} />}
                            onChange={onChangeHandler}
                        />
                    </div>
                </div>
            </div>
        </div>
    </ModalElement>
}

export default AddInstaller;